import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MMobileService } from '../../../core/services/common';
import { Document, Policy, PolicyReceipt } from '../../models/policy';
import { PolicyLife, PolicyLifeCertificate } from '../../models/policy-life';
import { PendingReceipt } from '../../models/receipt';
import { BaseService } from '../core/base.service';
import { OperationRegisterService } from '../core/operation-register.service';
@Injectable({
  providedIn: 'root'
})
export class LifePoliciesService {
  constructor(
    private http: HttpClient,
    private mmobile: MMobileService,
    private base: BaseService,
    private or: OperationRegisterService
  ) {}

  getLifePolicy(policy: PolicyLife): Observable<PolicyLife> {
    const { policyNumber, subpolicyNumber, type } = policy;
    let url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}?type=${type}`;
    if (subpolicyNumber) {
      url += `&subpolicyNumber=${subpolicyNumber}`;
    }
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    const params = this.or.setLifeOperationParams(policy);
    return this.http.get<PolicyLife>(url, { ...headers, params });
  }

  getLifeReceipts(policy: PolicyLife): Observable<PolicyReceipt[]> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${
      policy.policyNumber
    }/receipts`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    const params = this.or.setLifeOperationParams(policy);
    return this.http.get<PolicyReceipt[]>(url, { ...headers, params });
  }

  getLifeReceipt(
    policy: PolicyLife,
    receiptNumber: string
  ): Observable<PolicyReceipt> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${
      policy.policyNumber
    }/receipts/${receiptNumber}`;
    const params = this.or.setLifeOperationParams(policy);
    return this.http.get<PolicyReceipt>(url, {
      ...this.base.getPrivateOIMHeaders({ cacheResponse: true }),
      params
    });
  }

  getLifePendingReceipts(
    policyNumber: string,
    params: any
  ): Observable<PendingReceipt[]> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/receiptsPayment/receipts`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    return this.http.get<PendingReceipt[]>(url, { ...headers, params });
  }

  getLifePolicyFiscalCertificates(
    policyNumber: string,
    exercise: string,
    params?: HttpParams
  ): Observable<PolicyLifeCertificate[]> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/certificates?exercise=${exercise}`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    return this.http.get<PolicyLifeCertificate[]>(url, { ...headers, params });
  }

  getLifePolicyFiscalCertificate(
    policyNumber: string,
    model: string,
    exercise: string,
    params?: HttpParams
  ): Observable<Document> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/certificates/${model}?exercise=${exercise}`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    return this.http.get<Document>(url, { ...headers, params });
  }

  getLifeRenewalNotice(policy: Policy): Observable<Document> {
    const { policyNumber: lifePolicyNumber } = policy || {};
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${lifePolicyNumber}/documents/renewalNotice`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    const params = this.or.calculateDocumentROParams(policy);
    return this.http.get<Document>(
      url,
      { ...headers, params }
    );
  }

  getLifeGeneralConditions(
    policyNumber: string,
    params: HttpParams,
    productCode: string
  ): Observable<Document> {
    const url = `${this.base.getPrivateOIMBaseUrl()}/lifePolicies/${policyNumber}/documents/generalConditions?product=${productCode}`;
    const headers = this.base.getPrivateOIMHeaders({ cacheResponse: true });
    return this.http.get<Document>(url, { ...headers, params });
  }
}
